@use "~theme/typography";
@use "~theme/breakpoints";

.divider {
  width: 38%;
  float: left;
}

.mobileExpand {
  height: 80px;
  background: var(--gray-05);
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  border-radius: 4px;
  margin-bottom: 5px;

  @include breakpoints.mobile-large {
    width: 100%;
    margin: 0;
  }

  @include breakpoints.desktop {
    height: 70px;
    padding-left: 20px;
    padding-top: 5px;
  }
}

.mobileExpandCustom {
  height: 105px;
  background: var(--gray-05);
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  border-radius: 4px;
  margin-bottom: 5px;

  @include breakpoints.mobile-large {
    width: 100%;
    margin: 0;
  }

  @include breakpoints.desktop {
    height: 70px;
    padding-left: 20px;
    padding-top: 5px;
  }
}

.innerLeft {
  float: left;
  width: 70%;
  min-height: 60px;
  background: var(--white);
  border: 0.5px solid var(--blue-01-at-30);
  border-radius: 4px;
  margin: 10px 10px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  @include breakpoints.mobile-large {
    min-height: 60px;
  }

  @include breakpoints.desktop {
    min-height: 45px;
  }

  span {
    float: none;
    color: var(--blue-01);
    font-weight: var(--semibold-weight);
    flex: 1;
    word-break: break-word;
  }

  a {
    float: none;
    margin-top: 0 !important; // Override all margin-top
    margin-left: auto; // Push to right
    white-space: nowrap;
    flex-shrink: 0;
  }
}

.innerLeftCustom {
  float: left;
  width: 70%;
  min-height: 45px; // Changed from height to min-height
  background: var(--white);
  border: 0.5px solid var(--blue-01-at-30);
  border-radius: 4px;
  padding: 10px;
  margin: 15px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  
  @include breakpoints.desktop {
    min-height: 45px;
    margin: 7px 10px;
  }

  span {
    float: none;
    color: var(--blue-01);
    font-weight: var(--semibold-weight);
    flex: 1;
    word-break: break-word;
  }

  a {
    float: none;
    margin-top: 0 !important; // Override all margin-top
    margin-left: auto; // Push to right
    white-space: nowrap;
    flex-shrink: 0;
  }
}



.innerRight {
  float: right;
  margin: 15px;
}

.expandBtn {
  cursor: pointer;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  align-items: center;
  text-align: center;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--blue-01);
  border-radius: 4px;
  border: 2px solid var(--blue-01);
  width: 24%;
  height: 36px;
}

.innerCard {
  padding: 24px 27px;
  height: 87px;

  /* 03 Blue @ 30% */
  background: rgb(238 245 252 / 30%);

  /* 01 Blue @ 30% */
  border: 1px solid rgb(0 51 102 / 30%);
  border-radius: 4px;
}

.headLabel {
  color: var(--blue-01);
  font-size: 0.875rem;
  font-weight: var(--semibold-weight);
  line-height: 140%;
  letter-spacing: 0.02rem;
}

.removeExpand {
  font-weight: var(--semibold-weight);
  line-height: 140%;
  letter-spacing: 0.02rem;
  font-size: 1rem;
  color: var(--blue-01);
  margin: 0 0 4px;
  float: right;
  padding: 15px 0;
  text-decoration: none;
  text-align: center;

  img {
    margin-right: 10px;
  }
}

.removeForm {
  margin-top: -90px;
  margin-right: 40px;
  cursor: pointer;
  height: 80px;
}

.cardExpand {
  top: 90px;
  position: absolute;
  padding: 32px 32px 60px 29px;
  margin: 0 auto;
  min-width: var(--max-desktop-width);
  max-width: var(--max-desktop-width);
  height: 179px;
  max-height: 179px;
  background: var(--white);
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  border-radius: 8px;
  display: none;

  @include breakpoints.desktop {
    display: inline;
  }
}

.cardExpand2 {
  position: absolute;
  padding: 32px 32px 60px 29px;
  margin: 0 auto;
  min-width: var(--max-desktop-width);
  max-width: var(--max-desktop-width);
  height: 179px;
  max-height: 179px;
  background: var(--white);
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  border-radius: 8px;
  margin-top: 25px;
  display: none;

  @include breakpoints.desktop {
    display: inline;
  }
}

.errorFields {
  float: left;
  margin: 10px;
  font-size: 16px;
  line-height: 140%;
  text-align: right;
  letter-spacing: 0.02em;
  color: var(--red);

  img {
    margin-right: 10px;
  }

  p {
    margin: 0;
    float: right;
    padding-top: 2px;
  }
}

.errorFieldsMobile {
  float: left;
  font-size: 12px;
  color: var(--red);
  padding-left: 10px;
  clear: both;

  img {
    height: 12px;
    float: left;
    margin-right: 5px;
  }

  p {
    margin: 0;
    float: right;
    margin-top: -5px;
  }
}

.errorFieldsMobileCustom {
  float: left;
  font-size: 12px;
  color: var(--red);
  padding-left: 10px;
  clear: both;

  img {
    height: 12px;
    float: left;
    margin-right: 5px;
  }

  p {
    margin: 0;
    float: right;
    margin-top: -5px;
  }
}

.errorExpand {
  height: 115px;
}

.expandLayoutNone {
  margin-top: 0;
  margin-bottom: 0;
}

.expandLayoutIn {
  margin-top: 60px;
  margin-bottom: 0;

  @include breakpoints.desktop {
    margin-top: 180px;
  }
}

.expandLayoutInError {
  margin-top: 90px;

  @include breakpoints.desktop {
    margin-top: 180px;
  }
}

.expandLayoutOut {
  margin-top: 0;
  margin-bottom: 80px;

  @include breakpoints.desktop {
    margin-bottom: 160px;
  }
}

.expandLayoutOutError {
  margin-bottom: 100px;

  @include breakpoints.desktop {
    margin-bottom: 200px;
  }
}

.secondExpand {
  top: auto;
  margin-top: 10px;
}

.insurance {
  background-color: transparent;
  border-top: none;
  border-radius: 0;
  margin: 8px 24px 24px;
  padding: 20px 24px 0;
  text-align: center;
  cursor: pointer;
  overflow: hidden;

  @include breakpoints.desktop {
    margin: 12px 32px 32px;
    padding: 24px 32px 0;
  }
}

.addSpan {
  display: block;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: rgb(35 31 32 / 75%);

  @include breakpoints.desktop {
    font-size: 20px;
    line-height: 140%;
    margin-top: 40px;
  }
}

.header {
  font-weight: var(--semibold-weight);
  line-height: 150%;
  letter-spacing: 0.12rem;
  font-size: 16px;
  color: var(--blue-01);
  text-transform: uppercase;
  margin: 0 0 4px;

  img {
    margin-right: 6px;
    margin-bottom: 4px;
  }
}

.addInsurance {
  text-decoration: none;
}

.hideScroll {
  display: none;
}

.versionBG {
  // background: var(--gray-05);
  padding-left: 20px;
  padding-right: 20px;
}
